import React, { useContext, useMemo } from 'react';
import { filter, get, map } from 'lodash';

import AnswersDropdown from 'src/presentation/components/pages/shared/AnswersDropdown';
import { AnswerType } from 'src/presentation/components/pages/shared/hooks/useAnswersFilter';
import { CustomRow } from 'src/presentation/components/forms/CustomRow';
import { DropdownMediumWidth } from 'src/presentation/components/forms/Dropdown';
import endpointsResource from 'src/actions/endpoints/endpointsResource';
import { EndpointTypes } from 'src/models/Channels/endpointType';
import { FIELD_MAPPER } from 'src/presentation/components/pages/threads/ThreadsConstants';
import {
  FirstColumn,
  SecondColumn,
  ThreadAuthenticationEmailImage,
  ThreadSection,
} from 'src/presentation/components/pages/threads/ThreadsLayouts';
import FormContext from 'src/presentation/contexts/FormContext';
import { useResourceAll } from 'src/presentation/hooks/useResource';

const AuthenticationEmailSection = () => {
  const { values: endpoints } = useResourceAll(endpointsResource);

  const emailOptions = useMemo(
    () =>
      map(
        filter(endpoints, endpoint => endpoint.type === EndpointTypes.EMAIL),
        endpoint => ({ label: endpoint.address, value: endpoint.address })
      ),
    [endpoints]
  );

  const { workingState } = useContext(FormContext);

  const answerLanguage = get(workingState, FIELD_MAPPER.AUTHENTICATE_CUSTOMER_EMAIL_ANSWER_LANGUAGE.path, 'en-us');

  return (
    <>
      <FirstColumn>
        <ThreadSection
          header="Authentication Email"
          description="Select the email address and message for the authentication email."
        >
          <CustomRow>
            <DropdownMediumWidth
              options={emailOptions}
              label={FIELD_MAPPER.AUTHENTICATE_CUSTOMER_EMAIL_FROM.label}
              description={FIELD_MAPPER.AUTHENTICATE_CUSTOMER_EMAIL_FROM.description}
              data-aid={FIELD_MAPPER.AUTHENTICATE_CUSTOMER_EMAIL_FROM.path}
              attr={FIELD_MAPPER.AUTHENTICATE_CUSTOMER_EMAIL_FROM.path}
              placeholder={FIELD_MAPPER.AUTHENTICATE_CUSTOMER_EMAIL_FROM.placeholder}
            />
          </CustomRow>
          <CustomRow>
            <AnswersDropdown
              answerType={AnswerType.EMAIL}
              attr={FIELD_MAPPER.AUTHENTICATE_CUSTOMER_EMAIL_ANSWER_ID.path}
              description={FIELD_MAPPER.AUTHENTICATE_CUSTOMER_EMAIL_ANSWER_ID.description}
              label="Email message"
              language={answerLanguage}
              placeholder={FIELD_MAPPER.AUTHENTICATE_CUSTOMER_EMAIL_ANSWER_ID.placeholder}
            />
          </CustomRow>
        </ThreadSection>
      </FirstColumn>
      <SecondColumn>
        <ThreadAuthenticationEmailImage />
      </SecondColumn>
    </>
  );
};

export default AuthenticationEmailSection;
